import { SET_TOKEN, SET_PENDING, SET_ERROR, SIGN_OUT } from './types';

export const initialState = {
  token: null,
  pending: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case SET_PENDING:
      return {
        ...state,
        pending: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SIGN_OUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
